export default {
	project_name: 'Uniglobo',
	home_drills_title: 'DRILLS',
	home_events_title: 'MIS EVENTOS',
	home_keep_watching_title: 'CONTINUÁ VIENDO',
	home_library_title: 'BIBLIOTECA',
	home_live_classes_title: 'CLASES EN VIVO',
	home_news_title: 'NOVEDADES',
	home_online_courses_title: 'CURSOS ONLINE',
	home_podcasts_title: 'PODCASTS',
	home_surveys_title: 'BÚSQUEDAS',
	home_tags_title: 'DESTACADOS',
	home_trails_title: 'MÓDULOS DE CAPACITACIÓN',
	home_webinars_title: 'WEBINARS',
	navbar_about_title: 'CONÓCENOS',
}
